// removed by extract-text-webpack-plugin
module.exports = {"chip":"_3Iv9Pz5RR6aR-YyUkk6xBx","avatar":"_2o8mDjfbsT97HFsrCNypqu","deletable":"_2hlBs8I20e-n8Y8Lvzb630","delete":"_3nnfjiSXg7Vz17ZCSu0FfU","deleteIcon":"_2sopzPS5AEjQu3C4aH9IQB","deleteX":"_10NaZTSwrzed41qzrX9vYY"};


//////////////////
// WEBPACK FOOTER
// ./~/react-toolbox/lib/chip/theme.css
// module id = 1031
// module chunks = 0